import React from 'react';
import { KatDatePicker } from '@amzn/katal-react';
import styled from 'styled-components';
import { MANDATORY_FIELD_IDENTIFIER } from 'src/react-jsonschema-katal/katal/constants/ApplicationConstants';
import {
  dateDisabledOptions,
  DATE_DISABLED_FUNCTIONS,
} from './DatePickerHelper';
const DatePickerArea = styled.div`
  kat-date-picker {
    width: 100%;
    font-size: ${({ theme }) => theme.fontSize.m};
    --width: 100%;
    --font-size: ${({ theme }) => theme.fontSize.m};
  }
`;

interface IDatePicker extends KatDatePicker._OwnProps {
  onDateSelected: (date: string | Date) => void;
  required?: boolean;
  dateDisabledFunction: DATE_DISABLED_FUNCTIONS;
}

const DatePicker: React.FC<IDatePicker> = ({
  label,
  value,
  dateDisabledFunction = DATE_DISABLED_FUNCTIONS.DATE_LESS_THAN_TODAY,
  onDateSelected,
  disabled = false,
  locale = 'en-US',
  required = false,
  ...props
}) => {
  if (required) {
    label = `${label}${MANDATORY_FIELD_IDENTIFIER}`;
  }
  return (
    <DatePickerArea data-testid="DatePickerAreaTestId">
      <KatDatePicker
        disabled={disabled}
        value={value}
        label={label}
        locale={locale}
        isDateDisabled={dateDisabledOptions(dateDisabledFunction)}
        onChange={(e: KatDatePicker.ChangeEvent) =>
          onDateSelected(e.detail.value)
        }
        {...props}
      />
    </DatePickerArea>
  );
};

export default DatePicker;
